import * as AddBySupcActions from '../actions/AddBySupcActions';
import type { IAddBySupcState } from '../appstate';
import { CreateLoaderReducer } from './GeneralReducers';

const initialState: IAddBySupcState = {
	productNumberDescriptionLookup: {},
	productValidation: {
		payload: null,
		inProcess: false,
		error: false,
	},
};

const productValidationReducer = CreateLoaderReducer({
	startAction: AddBySupcActions.SEARCH_PRODUCT_NUMBER,
});

export function addBySupcReducer(state = initialState, action): any {
	switch (action.type) {
		case AddBySupcActions.SEARCH_PRODUCT_NUMBER:
		case AddBySupcActions.SEARCH_PRODUCT_NUMBER_ERROR:
			return {
				...state,
				productValidation: productValidationReducer(
					state.productValidation,
					action
				),
			};
		case AddBySupcActions.SEARCH_PRODUCT_NUMBER_SUCCESS: {
			let newLookup = state.productNumberDescriptionLookup;

			if (action.payload) {
				newLookup = {
					...state.productNumberDescriptionLookup,
				};

				for (const productNumber in action.payload) {
					if (
						!Object.prototype.hasOwnProperty.call(action.payload, productNumber)
					) {
						continue;
					}
					newLookup[productNumber] = action.payload[productNumber];
				}
			}

			return {
				productNumberDescriptionLookup: newLookup,
				productValidation: productValidationReducer(
					state.productValidation,
					action
				),
			};
		}
		case AddBySupcActions.RESET_PRODUCT_VALIDATION_AND_LOOKUP:
			return {
				...initialState,
			};
	}
	return state;
}
